import { FC } from 'react';

import styles from '../../EncounterDetails.module.scss';
import { EncounterTab } from '../../hooks';

import { EncounterTabButton } from './EncounterTabButton';

type EncounterTabsProps = {
  activeTab: EncounterTab | undefined;
  canViewEvaluation: boolean;
  evaluationScore: number | undefined;
  tabs: EncounterTab[];
  onTabChange: (tab: EncounterTab) => void;
};

export const EncounterTabs: FC<EncounterTabsProps> = (props) => {
  const { activeTab, canViewEvaluation, evaluationScore, tabs, onTabChange } =
    props;

  return (
    <nav className={styles.tabs} role="tablist" data-component="encounter-tabs">
      {tabs.map((tab) => (
        <EncounterTabButton
          key={tab.value}
          canViewEvaluation={canViewEvaluation}
          evaluationScore={evaluationScore}
          isActive={tab.value === activeTab?.value}
          tab={tab}
          onClick={onTabChange}
        />
      ))}
    </nav>
  );
};
